import React, { useState, useEffect } from "react"
import { useLocation } from '@reach/router'
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { notBlank, secColorBg, hashCode, jnstyls, imgSize } from '~/utils/helpers'


import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/shared/swatches.module.scss"

const SwatchGroup = ({ prod_handle, color_group, trim=false, onInteraction, gaInteract=false, colorClick=false }) => {
  const { plineInv, pdpVariant, quick, isSHM } = useTheme()
  const location = useLocation()

  const [pdp, setPdp] = useState(false)

  const num = color_group.length
  const color_arr = trim ? color_group.slice(0,trim) : color_group

  const handleEnter = (name) => {
    if (!name) onInteraction(false)

    onInteraction(name[0]);
    if (name[1]) {
      const testimg = new Image();
      testimg.src = name[1];
    }
  }

  const handleClick = (handle, action) => {
    if (gaInteract) gaInteract(action)
    if (colorClick) colorClick(handle)
  }

  const checkInv = (shop_id) => {
    if (trim || !(plineInv && pdpVariant.title) ) return ''
    const prod = plineInv.find(x => x.id === shop_id)
    if ( !prod || !prod.variants ) return ''

    const color_var = prod.variants.find(x => x.title === pdpVariant.title)
    if ( !color_var ) return styles.oos 
    const fulfill = prod.fulfill[pdpVariant.title]

    const wh_combo = (color_var.inv.DW || color_var.inv['BL - Ecommerce'] || false)
    const ship_avail = !isSHM ? fulfill?.ship : wh_combo
    
    if ( !fulfill ) return ''
    return color_var?.available && (ship_avail || fulfill?.pickup) ? '' : styles.oos 
  }

  useEffect(() => {
    setPdp( location.pathname.includes('/products/') )
  }, [location])
  

  return (
    <div 
      className={jnstyls([styles.swatches, !trim ? styles.pdp_swatches : '', (!pdp && !quick) ? styles.cs : ''])}
      role="menu" 
      tabIndex={!trim ? 0 : -1} 
      aria-labelledby={!trim ? `ar_label-select_${color_arr[0].handle.includes('venice') ? 'venice' : 'core'}` : undefined}
    >
      {color_arr.map( (color, index) => {
        const is_pdp_color = color.handle === prod_handle
        const sec_color = color.second_color_hex
        const whites = ['#fff','#ffffff','#fafafa'] 
        const is_white = whites.includes(color.hex_color)
        const oos = checkInv(color.shop_id)
        
        const basecolor = color.hex_color || '#ff0000'
        const style_obj = {
          '--bgcolor': basecolor,
          border: is_white ? '1px solid #999' : '0'
        }
        if (sec_color && !notBlank(oos)) style_obj['--seccolor'] = sec_color
        if (sec_color && notBlank(oos)) {
          style_obj['--bgcolor'] = `color-mix(in srgb, transparent, ${basecolor} 60%)`;
          style_obj['--seccolor'] = `color-mix(in srgb, transparent, ${sec_color} 60%)`;
        }
        if (color.sw_img) {
          style_obj.backgroundImage = `url(${imgSize(color.sw_img, 300)})`
          style_obj.backgroundSize = 'cover'
          style_obj.backgroundRepeat = 'no-repeat'
        }

        return (
          <div key={`${hashCode(prod_handle)}${hashCode(color.handle)}${index}`}>
            {pdp ? (
              <>
                {is_pdp_color  ? (
                  <div
                    className={jnstyls([styles.nswatch, oos, sec_color ? styles.scolor : '', styles.scurr])}
                    style={style_obj} 
                    tabIndex="-1"
                    role="menuitem" 
                    aria-current={is_pdp_color ? 'true' : 'false'}
                    aria-label={`${is_pdp_color ? `${color.name} currently selected` : `Select ${color.name}`}`}
                    onMouseEnter={(e) => handleEnter([color.name,color.image])}
                    onMouseLeave={(e) => handleEnter(false)}
                  >
                  </div>
                ) : (
                  <Flink
                    className={jnstyls([styles.nswatch, oos, sec_color ? styles.scolor : ''])}
                    href={`/products/${color.handle}`}
                    style={style_obj} 
                    tabIndex="-1"
                    role="menuitem"  
                    aria-current={is_pdp_color ? 'true' : 'false'}
                    aria-label={`${is_pdp_color ? `${color.name} currently selected` : `Select ${color.name}`}`}
                    onMouseEnter={(e) => handleEnter([color.name,color.image])}
                    onMouseLeave={(e) => handleEnter(false)}
                  >
                  </Flink>
                )}
              </>
            ) : (
              <button
                type="button"
                className={jnstyls([aria_btn, styles.nswatch, oos, sec_color ? styles.scolor : '', is_pdp_color ? styles.scurr : ''])}
                style={style_obj} 
                role="menuitem"  
                aria-current={is_pdp_color ? 'true' : 'false'}
                aria-label={`${is_pdp_color ? `${color.name} currently selected` : `Select ${color.name}`}`}
                onMouseEnter={(e) => handleEnter([color.name,color.image])}
                onMouseLeave={(e) => handleEnter(false)}
                onClick={(e)=> handleClick(color.handle, 'tile click: swatch')}
              />
            )}
          </div>
        )
      })}
      {trim && num > 8 && (
        <div className={styles.colors_more} tile-cmore=''>
          <button 
            type="button"
            className="aria_btn" 
            aria-label="See all color options, opens a dialog" 
            onClick={(e)=> handleClick(prod_handle, 'tile click: more colors')}
          >
            + {num - 8} More
          </button>
        </div>
      )}
    </div>
  );
};

export default SwatchGroup